/* eslint-disable no-alert */
import React from 'react'
import moment from 'moment'
import { Header, Table, Pagination } from 'semantic-ui-react'
import styled from 'styled-components'
import _ from 'lodash'

import DateRangeSearch from './DateRangeSearch'
import CashOutRow from './CashOutRow'
import DownloadButton from './Download'

const SearchBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const Total = styled.p`
  color: rgb(208, 62, 62);
  font-weight: bold;
  font-size: 20px;
`

const HEADER = [
  { name: 'Transaction ID', width: 210 },
  { name: 'Name' },
  { name: 'Phone' },
  { name: 'ABA Number' },
  { name: 'ABA Name' },
  { name: 'Amount' },
  { name: 'Request Date' },
  { name: 'Transfer Date' },
  { name: 'Status|Actions', width: 156 },
]
class CashOutList extends React.Component {
  state = {
    from: Number(
      moment()
        .startOf('day')
        .format('x')
    ),
    to: Number(
      moment()
        .endOf('day')
        .format('x')
    ),

    currentPage: 1,
  }

  handlePaginationChange = (e, { activePage }) => this.setState({ currentPage: activePage })

  renderRows = () => {
    const { cashOuts, confirmCashOut, cancelCashOut, numberPerPage } = this.props
    const { currentPage } = this.state

    const begin = (currentPage - 1) * numberPerPage
    const end = begin + numberPerPage

    const displayCashOuts = _.slice(cashOuts, begin, end)

    return displayCashOuts.map(cashOut => (
      <CashOutRow
        key={cashOut.id}
        cashOut={cashOut}
        confirmCashOut={confirmCashOut}
        cancelCashOut={cancelCashOut}
      />
    ))
  }

  renderNoData = () => {
    return (
      <Table.Row>
        <Table.Cell key="header" colSpan={HEADER.length} textAlign="center" style={{ padding: 40 }}>
          <Header size="small">No data available</Header>
        </Table.Cell>
      </Table.Row>
    )
  }

  renderFakeRow = () => (
    <Table.Body>
      <Table.Row>
        {HEADER.map(header => {
          return (
            <Table.Cell key={header.name} style={{ paddingTop: 0, paddingBottom: 0 }}>
              {header.width ? <div style={{ width: header.width }} /> : null}
            </Table.Cell>
          )
        })}
      </Table.Row>
    </Table.Body>
  )

  renderDateRangeSearch = () => {
    const { tab, loading, getHistoryCashOuts, cashOuts } = this.props

    if (tab !== 'history') return null

    const { from, to } = this.state
    const startFrom = moment(parseInt(from, 10)).format('YYYY-MM-DD')
    const endAt = moment(parseInt(to, 10)).format('YYYY-MM-DD')
    const totalAmount = _.sumBy(cashOuts, cashOut => {
      if (cashOut.status === 'cancelled') return 0

      return cashOut.amount
    })
    return (
      <React.Fragment>
        <SearchBar>
          <DateRangeSearch
            start={startFrom}
            end={endAt}
            loading={loading}
            onButtonClick={() => getHistoryCashOuts(from, to)}
            onStartChange={value => this.setState({ from: value })}
            onEndChange={value => this.setState({ to: value })}
          />
          <Total>Transferred: $ {parseFloat(totalAmount).toFixed(2)}</Total>
        </SearchBar>
        <DownloadButton
          header={HEADER.map(head => (head.name === 'Status|Actions' ? 'Status' : head.name))}
          data={cashOuts}
          filename={`cashout-${startFrom}-${endAt}`}
        />
      </React.Fragment>
    )
  }

  renderPagination = () => {
    const { currentPage } = this.state
    const { numberOfPages } = this.props

    if (numberOfPages < 2) return null
    return (
      <Pagination
        activePage={currentPage}
        onPageChange={this.handlePaginationChange}
        totalPages={numberOfPages}
        floated="right"
      />
    )
  }

  render() {
    const { cashOuts, tab } = this.props
    const contentHeight = tab === 'history' ? 'calc(100vh - 320px)' : 'calc(100vh - 270px)'

    return (
      <div>
        <div style={{ padding: 14 }}>
          {this.renderDateRangeSearch()}
          <Table columns={HEADER.length}>
            <Table.Header>
              <Table.Row>
                {HEADER.map((header, ind) => {
                  const { name } = header
                  const headerName =
                    name === 'Status|Actions'
                      ? tab === 'history'
                        ? name.split('|')[0]
                        : name.split('|')[1]
                      : name

                  return (
                    <Table.HeaderCell key={ind} textAlign={ind === 0 ? 'left' : 'center'}>
                      {headerName}
                    </Table.HeaderCell>
                  )
                })}
              </Table.Row>
            </Table.Header>
            {this.renderFakeRow()}
          </Table>
        </div>
        <div
          style={{ height: contentHeight, overflow: 'auto', padding: '0px 14px' }}
          className="list-content"
        >
          <Table columns={HEADER.length}>
            <Table.Body>{cashOuts.length > 0 ? this.renderRows() : this.renderNoData()}</Table.Body>
          </Table>
          {this.renderPagination()}
        </div>
      </div>
    )
  }
}

export default CashOutList



// WEBPACK FOOTER //
// ./src/containers/cashOuts/components/CashOutList.js